module.exports = __webpack_public_path__ + "img/checkmark.e4511341.svg";